import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='commentary-disclosure-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={8}>
        <Typography
          component='h1'
          nextElement='typography'>
          Economic <WidowBlock>Commentary Disclosures</WidowBlock>
        </Typography>
        <Typography
          align='left'
          disableBottomPadding>
          We want to make understanding commentary and investing easier for you so we created this page to provide definitions and some more information about risks that investments of all kinds have. Remember, there are risks with all investments but understanding the different types of risk can help you create the right investment strategy for you.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
